// src/lib/attribution.js
//
// A látogató érkezési forrását az ELSŐ oldalbetöltéskor kell elkapni: egy SPA-ban
// a felhasználó pár kattintás után már egy olyan URL-en áll, amin nincs rajta az
// utm_source vagy az fbclid. Ezért itt egyszer eltesszük, és a lead beküldésekor
// innen olvassuk vissza.
//
// sessionStorage-ban tároljuk: a fül bezárásakor magától eltűnik, és csak akkor
// hagyja el a böngészőt, ha a látogató ténylegesen beküld egy űrlapot.

const KEY = "teleport_attribution";

const PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
];

let cached = null;

function read() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function write(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    // privát mód – marad a memóriabeli példány
  }
}

// Az alkalmazás indulásakor egyszer hívjuk (AnalyticsTracker).
export function captureAttribution() {
  if (typeof window === "undefined") return {};
  if (cached) return cached;

  const stored = read();
  if (stored) {
    cached = stored;
    return cached;
  }

  const search = new URLSearchParams(window.location.search);
  const data = { landing_page: window.location.href };

  PARAMS.forEach((name) => {
    const value = search.get(name);
    if (value) data[name] = value;
  });

  // Csak a külső hivatkozó érdekes, a saját oldalunkon belüli lépés nem
  if (document.referrer && !document.referrer.startsWith(window.location.origin)) {
    data.referrer = document.referrer;
  }

  cached = data;
  write(data);
  return cached;
}

export function getAttribution() {
  if (cached) return cached;
  cached = read() || {};
  return cached;
}
